// extracted by mini-css-extract-plugin
export default {"container":"Icon_container__n+fB3","image":"Icon_image__k8Wh3"};